import React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import {
  PrimaryButton,
  ComponentProps as PrimaryButtonsProps,
} from 'lib/components/buttons/PrimaryButton';
import { theme } from 'lib/style';
import { MdFileUpload } from 'react-icons/md';
import { BoardModal } from './boardModal/BoardModal';

const Container = styled.div`
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${theme.palette.coal};
  margin-bottom: 16px;
`;

const StyledButton = styled(PrimaryButton)`
  height: 40px;
  font-size: ${theme.fontSizes.m};
  font-weight: 600;
  border-radius: 5px;
  margin-right: 16px;
`;

const IconBtn = (props: PrimaryButtonsProps) => (
  <StyledButton
    center={true}
    iconPadding={8}
    textPadding='16px 16px 16px 0px'
    {...props}
  />
);

interface Props {
  boardType?: string;
}
export const EmptyBoards = ({ boardType = 'owned' }: Props) => {
  const themes = useTheme();
  const [showCreateBoardModal, setShowCreateBoardModal] = React.useState(false);
  const emptyTitle =
    boardType === 'owned'
      ? 'You don’t have created Boards.'
      : 'You don’t have shared Boards.';

  return (
    <Container>
      <Title>{emptyTitle}</Title>
      {boardType === 'owned' && (
        <IconBtn
          text='Create Board'
          backgroundColor={themes.colors.primaryColor}
          textColor={themes.colors.primaryButtonTextColor}
          icon={
            <MdFileUpload
              size='18px'
              color={themes.colors.primaryButtonTextColor}
            />
          }
          onClick={() => setShowCreateBoardModal(true)}
        />
      )}

      {showCreateBoardModal && (
        <BoardModal handleModalClose={() => setShowCreateBoardModal(false)} />
      )}
    </Container>
  );
};
